import { defineResource } from 'pulse/resources';
import { listConversationsResolver } from './resolver';
export const ConversationsList = defineResource({
  typeName: 'academy-ai-assistant-lib:ConversationsList',
  args: ['agentId', 'limit', {
    field: 'offset',
    default: undefined
  }, 'scope'],
  resolver: listConversationsResolver
}).register();